import type {
  DesignWidgetType,
  SerializableDesign,
} from "./lib/serializableDesign";

export type { DesignWidgetType, SerializableDesign };

export type DesignModerationStatus =
  | "draft"
  | "pending"
  | "approved"
  | "rejected";

export type DesignLicense = "free" | "paid";

export const DESIGN_WIDGET_TYPES: DesignWidgetType[] = [
  "timer",
  "countdown",
  "clock",
  "chat",
  "playlist",
  "social",
  "subgoal",
  "followergoal",
  "viewers",
  "progressbar",
  "crawl",
];

/** Mirrors the backend `DesignResponseDto`. */
export interface Design {
  id: string;
  slug: string;
  name: string;
  subtitle?: string | null;
  widgetType: DesignWidgetType;
  category: string;
  description?: string | null;
  /** Full serializable payload — rendered client-side for the preview. */
  design: SerializableDesign;
  swatches: string[];
  fonts: string[];
  cardWidth: number;
  cardHeight: number;
  tags: string[];
  status: DesignModerationStatus;
  authorId?: string | null;
  license: DesignLicense;
  priceArs?: number | null;
  installCount: number;
  version: string;
  createdAt: string;
  updatedAt: string;
}

export interface ListDesignsQuery {
  status?: DesignModerationStatus;
  widgetType?: DesignWidgetType;
  q?: string;
  sort?: "popular" | "newest" | "rating";
  page?: number;
  limit?: number;
}

export interface ListDesignsResponse {
  data: Design[];
  total: number;
  page: number;
  limit: number;
}

export interface ModerateDesignBody {
  decision: "approved" | "rejected";
  note?: string;
}
